// extracted by mini-css-extract-plugin
export default {"fallbackContainer":"FallbackBanner_fallbackContainer__s9iRk"};